export const auhtorizationForReleaseOfMedicalInformation = (date?: string) => {
  return [
    { text: 'Authorization For Release Of Medical Information', style: 'h1' },

    { text: 'I acknowledge that I have been requested by SIERRA EXPEDITING INC to submit to drug and/or alcohol testing to be administered by Comprehensive Medical, Inc, a laboratory service designated and chosen by SIERRA EXPEDITING INC, whose purpose and function is to determine whether I am able to perform my described job duties.', style: 'p' },

    { text: 'I hereby authorize the laboratory to disclose all pertinent medical information and all laboratory results to SIERRA EXPEDITING INC. The release by the laboratory of the information and results, and the utilization of the information and results by SIERRA EXPEDITING INC shall be for the limited purpose of providing SIERRA EXPEDITING INC an opportunity to evaluate the information and results and thereby determine whether I am fit to perform my job. The laboratory is only authorized to release the information and results for a period of up to and including 120 days from the date indicated below.', style: 'p' },

    { text: 'This information shall include laboratory, scientific and other reports and/or tests; analysis of my condition and substances and/or chemicals which are casual factors for my condition; diagnosis and prognosis as related to this drug and/or alcohol test.', style: 'p' },

    { text: 'I acknowledge that executing this authorization is voluntary and that I have the right to receive a copy of this authorization if I request one.', style: 'p' },

    {
      canvas: [
        {
          type: 'line',
          x1: 0,
          y1: 0,
          x2: 200,
          y2: 0,
          lineWidth: 1,
          lineColor: 'black',
        },
        {
          type: 'line',
          x1: 500,
          y1: 0,
          x2: 350,
          y2: 0,
          lineWidth: 1,
          lineColor: 'black',
        },
      ],
      style: 'input',
      margin: [0, 40, 0, 0]
    },

    { text: "Driver's Signature", style: 'label', margin: [0, 2, 0, 0] },
    { text: `${date}`, margin: [350, -32, 0, 0] },
    { text: "Date", style: 'label', margin: [350, 5, 0, 0] },

    {
      canvas: [
        {
          type: 'line',
          x1: 0,
          y1: 0,
          x2: 200,
          y2: 0,
          lineWidth: 1,
          lineColor: 'black',
        },
        {
          type: 'line',
          x1: 500,
          y1: 0,
          x2: 350,
          y2: 0,
          lineWidth: 1,
          lineColor: 'black',
        },
      ],
      style: 'input',
      margin: [0, 40, 0, 0]
    },

    { text: "Supervisor / Manager Signature", style: 'label', margin: [0, 2, 0, 0] },
    { text: `${date}`, margin: [350, -32, 0, 0] },
    { text: "Date", style: 'label', margin: [350, 5, 0, 0] },

    {
      canvas: [
        {
          type: 'line',
          x1: 0,
          y1: 0,
          x2: 200,
          y2: 0,
          lineWidth: 1,
          lineColor: 'black',
        },
        {
          type: 'line',
          x1: 500,
          y1: 0,
          x2: 350,
          y2: 0,
          lineWidth: 1,
          lineColor: 'black',
        },
      ],
      style: 'input',
      margin: [0, 40, 0, 0]
    },

    { text: "Witness Signature", style: 'label', margin: [0, 2, 0, 0] },
    { text: `${date}`, margin: [350, -32, 0, 0] },
    { text: "Date", style: 'label', margin: [350, 5, 0, 0] },

    { text: '', pageBreak: 'before' },
  ];
};